import React from 'react'
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom'

const SUPPORTED_LANGUAGES = ['en', 'ar', 'fa']

const isResetPasswordPath = (pathname = '') => /reset-password/i.test(pathname)

/**
 * Ensures /:lang is only matched for real language codes.
 * Without this, /events/my-slug is treated as lang=events and renders a blank page.
 * Strapi reset emails use /auth/reset-password, which would otherwise match lang=auth
 * and then redirect to /en/auth/reset-password — an unmatched nested route (white page).
 */
const ValidLanguageGuard = () => {
  const { lang } = useParams()
  const location = useLocation()

  if (isResetPasswordPath(location.pathname) && !SUPPORTED_LANGUAGES.includes(lang)) {
    return <Navigate to={`/reset-password${location.search}${location.hash}`} replace />
  }

  if (!SUPPORTED_LANGUAGES.includes(lang)) {
    return <Navigate to={`/en${location.pathname}${location.search}${location.hash}`} replace />
  }

  return <Outlet />
}

export const LanguageCatchAll = () => {
  const { lang } = useParams()
  const location = useLocation()

  if (isResetPasswordPath(location.pathname)) {
    return <Navigate to={`/reset-password${location.search}${location.hash}`} replace />
  }

  const safe = SUPPORTED_LANGUAGES.includes(lang) ? lang : 'en'
  return <Navigate to={`/${safe}/`} replace />
}

export default ValidLanguageGuard
